/* KleitasTev: compact Latvian cookie consent (v12: idempotent + debounced, no mutation loop) */
(function(){
  const LANG=(document.documentElement.lang||'').toLowerCase();
  const IS_LT=LANG.indexOf('lt')===0;
  const IS_ET=LANG.indexOf('et')===0;
  const LV=IS_LT?{
    title:'Slapukai',
    message:'Naudojame slapukus svetainės veikimui, analizei ir geresnei apsipirkimo patirčiai.',
    accept:'Priimti visus', decline:'Atmesti', settings:'Nustatymai', privacy:'Privatumo politika'
  }:IS_ET?{
    title:'Küpsised',
    message:'Kasutame küpsiseid veebilehe toimimiseks, analüütikaks ja parema ostukogemuse jaoks.',
    accept:'Nõustu kõigiga', decline:'Keeldu', settings:'Seaded', privacy:'Privaatsuspoliitika'
  }:{
    title:'Sīkdatnes',
    message:'Izmantojam sīkdatnes vietnes darbībai, analīzei un labākai iepirkšanās pieredzei.',
    accept:'Pieņemt visas', decline:'Noraidīt', settings:'Iestatījumi', privacy:'Privātuma politika'
  };

  function setText(el,v){ if(el&&el.textContent!==v) el.textContent=v; }

  function allRoots(){
    const out=[document], seen=new Set(out);
    function walk(root){
      try{root.querySelectorAll('*').forEach(el=>{if(el.shadowRoot&&!seen.has(el.shadowRoot)){seen.add(el.shadowRoot);out.push(el.shadowRoot);walk(el.shadowRoot);}})}catch(e){}
    }
    walk(document); return out;
  }

  function leafs(root){try{return [...root.querySelectorAll('h1,h2,h3,p,button,a,span,div')].filter(x=>!x.children.length)}catch(e){return[]}}
  function norm(s){return (s||'').replace(/\s+/g,' ').trim().toLowerCase()}

  function findDialog(root){
    let title=leafs(root).find(el=>/^(cookie consent|cookie preferences|privacy preferences|sīkdatnes|sīkdatņu iestatījumi|slapukai|slapukų nustatymai|küpsised|küpsiste seaded)$/.test(norm(el.textContent)));
    if(!title) return null;
    let p=title;
    for(let i=0;p&&i<10;i++,p=p.parentElement){
      const t=norm(p.textContent);
      if(p.querySelectorAll&&p.querySelectorAll('button').length>=2&&(t.includes('accept')||t.includes('pieņemt')||t.includes('priimti')||t.includes('nõustu'))) return {title,panel:p};
    }
    return {title,panel:title.parentElement};
  }

  function style(panel){
    if(!panel)return;
    const S=(el,k,v)=>{ if(el&&el.style.getPropertyValue(k)!==v) el.style.setProperty(k,v,'important'); };
    const mobile=innerWidth<=740;
    S(panel,'box-sizing','border-box');S(panel,'width','calc(100% - 24px)');S(panel,'max-width','480px');S(panel,'padding','14px');S(panel,'margin','12px auto');S(panel,'border-radius','10px');S(panel,'max-height','calc(100vh - 24px)');S(panel,'overflow','auto');
    panel.querySelectorAll('h1,h2,h3').forEach(x=>{S(x,'font-size','18px');S(x,'line-height','1.2');S(x,'margin','0 0 7px');});
    panel.querySelectorAll('p').forEach(x=>{S(x,'font-size','13px');S(x,'line-height','1.35');S(x,'margin','0 0 10px');});
    panel.querySelectorAll('button').forEach(x=>{S(x,'min-height','38px');S(x,'padding','7px 9px');S(x,'font-size','13px');});
    panel.querySelectorAll('a').forEach(x=>{S(x,'font-size','12px');});
    if(mobile){
      S(panel,'width','calc(100% - 16px)');S(panel,'padding','10px 12px');S(panel,'margin','8px auto');S(panel,'border-radius','8px');S(panel,'max-height','40vh');
      panel.querySelectorAll('h1,h2,h3').forEach(x=>{S(x,'display','none');});
      panel.querySelectorAll('p').forEach(x=>{S(x,'font-size','12px');S(x,'line-height','1.3');S(x,'margin','0 0 8px');});
      panel.querySelectorAll('a').forEach(x=>{S(x,'font-size','11px');});
      const btns=[...panel.querySelectorAll('button')];
      btns.forEach(x=>{S(x,'min-height','34px');S(x,'padding','5px 8px');S(x,'font-size','12px');S(x,'flex','1 1 0');S(x,'margin','0');});
      const wrap=btns.length&&btns[0].parentElement;
      if(wrap&&wrap!==panel){S(wrap,'display','flex');S(wrap,'flex-direction','row');S(wrap,'flex-wrap','nowrap');S(wrap,'gap','6px');S(wrap,'margin','0');S(wrap,'padding','0');}
    }
  }

  function translate(root){
    const found=findDialog(root); if(!found)return;
    const {title,panel}=found; setText(title,LV.title);
    const nodes=[...panel.querySelectorAll('h1,h2,h3,p,button,a,span,div')];
    let msg=nodes.find(el=>el.tagName==='P'&&/(we and our partners|including shopify|use cookies|personalize your experience|perform analytics|izmantojam sīkdatnes|naudojame slapukus|kasutame küpsiseid)/i.test(el.textContent||''));
    if(!msg) msg=nodes.find(el=>!el.children.length&&/(we and our partners|including shopify|use cookies|izmantojam sīkdatnes|naudojame slapukus|kasutame küpsiseid)/i.test(el.textContent||''));
    if(msg && (msg.textContent||'').indexOf(LV.message)!==0){
      const oldLink=msg.querySelector&&msg.querySelector('a'); const href=oldLink&&oldLink.href;
      msg.textContent=LV.message+' ';
      if(href){const a=document.createElement('a');a.href=href;a.textContent=LV.privacy;msg.appendChild(a);}
    }
    leafs(panel).forEach(el=>{
      const t=norm(el.textContent);
      if(/^(accept all|allow all)$/.test(t))setText(el,LV.accept);
      else if(/^(decline|reject|reject all)$/.test(t))setText(el,LV.decline);
      else if(/^(settings|preferences|manage preferences|cookie settings)$/.test(t))setText(el,LV.settings);
      else if(t==='privacy policy')setText(el,LV.privacy);
    });
    style(panel);
  }

  function scan(){ try{ allRoots().forEach(translate); }catch(e){} }

  /* Debounced: our own text edits can no longer retrigger an endless mutation loop. */
  let pending=false, runs=0;
  function schedule(){
    if(pending||runs>40)return;
    pending=true;
    setTimeout(function(){ pending=false; runs++; scan(); },250);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else schedule();
  /* Only watch for added/removed nodes (banner appearing); ignore text ticks such as the countdown timer. */
  new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true});
  [300,1000,2500,5000].forEach(t=>setTimeout(scan,t));
})();
